import { useIsBestsellers } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsBestsellers";
import { useIsHubCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsHubCategory";

export const useIsFullWidthCategory = () => {
  const { isHubCategory } = useIsHubCategory();
  const { isBestsellers } = useIsBestsellers();

  return !isHubCategory || isBestsellers;
};
